export default __webpack_public_path__ + "static/wand-education_small-image_1-54e840b62f96ea650a0fe98e70c8cbf2.webp";